import { AxiosResponse } from 'axios';

import { phpApi } from '../default';

export const downloadCertificate: (id: number) => Promise<AxiosResponse<void>> = (
  id: number
): Promise<AxiosResponse<void>> => phpApi.get(`/download/certificate/${id}`, { responseType: 'blob' });

export const downloadByFileType: (fileType: string, id: number) => Promise<AxiosResponse<void>> = (
  fileType: string, id: number
): Promise<AxiosResponse<void>> => phpApi.get(`/download/${fileType}/${id}`, { responseType: 'blob' });

export const downloadFormDocument: (documentId: number) => Promise<AxiosResponse<void>> = (
  documentId: number
): Promise<AxiosResponse<void>> => phpApi.get(`/download/form/doc/${documentId}`, { responseType: 'blob' });

export const downloadFormDocumentArchive: (id: number) => Promise<void> = (
  id: number
): Promise<void> => phpApi.get(`/download/form/doc-archive/${id}`, { responseType: 'blob' });

export const downloadFormEmptyDocument: (formId: number, typeCode: string) => Promise<AxiosResponse<void>> = (
  formId: number, typeCode: string
): Promise<AxiosResponse<void>> => phpApi.get(`/download/form-attachment/${formId}/download/${typeCode}`, { responseType: 'blob' });

export const downloadFormFileByTypeCodeAsStream: (formId: number, typeCode: string) => Promise<AxiosResponse<string>> = (
  formId: number, typeCode: string
): Promise<AxiosResponse<string>> => phpApi.get(
  `/download/form-uploaded/${formId}/stream/${typeCode}`, { customEnv: { notEncryptedResponse: true } }
);

export const downloadUserDocument: (id: number) => Promise<void> = (
  id: number
): Promise<void> => phpApi.get(`/download/user/doc/${id}`, { responseType: 'blob' });

export const downloadFile: (id: number) => Promise<AxiosResponse<void>> = (
  id: number
): Promise<AxiosResponse<void>> => phpApi.get(`/download/file/${id}`, { responseType: 'blob' });

export const downloadFileAsBlob: (id: number) => Promise<AxiosResponse<Buffer>> = (
  id: number
): Promise<AxiosResponse<Buffer>> => phpApi.get(`/download/file/${id}`, { responseType: 'blob', customEnv: { skipSaveAs: true } });
